import { useEffect, useState } from 'react';
import { Alert, Button, Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { ackWizardAlert, loadWizardAlerts } from '../slices/thunk';
import { buildRepeatExpiryMessage } from './repeatExpiryText';

// Beyond this many bars the dashboard cards get pushed off screen, so the rest
// collapse behind a toggle instead.
const COLLAPSE_AFTER = 3;

// Stable reference, so components don't re-render on every unrelated store touch.
const EMPTY = Object.freeze([]);

/**
 * Dashboard warning bars for repetitions that are about to run out.
 *
 * Reads the shared WizardAlerts slice rather than fetching for itself: the
 * sidebar badge counts the same list, so acknowledging a bar here has to clear
 * the badge on the same frame.
 */
const RepeatExpiryAlerts = ({ onEdit, reloadKey }) => {
  const dispatch = useDispatch();
  const alerts = useSelector((s) => s.WizardAlerts?.list) || EMPTY;
  const [expanded, setExpanded] = useState(false);

  // Refetch on mount as well as after an edit (which bumps reloadKey).
  // AuthProtected loads the list once at login, but a repetition extended from
  // the transactions page would leave the sidebar badge stale until something
  // reloads it -- and the dashboard is where the user comes to act on these.
  useEffect(() => {
    dispatch(loadWizardAlerts());
  }, [dispatch, reloadKey]);

  if (!alerts.length) {
    return null;
  }

  const shown = expanded ? alerts : alerts.slice(0, COLLAPSE_AFTER);
  const hiddenCount = alerts.length - shown.length;

  return (
    <div style={{ marginBottom: 16 }}>
      {shown.map((alert) => {
        const { message, description } = buildRepeatExpiryMessage(alert);
        return (
          <Alert
            key={alert.wizard_id}
            type={alert.is_lapsed ? 'error' : 'warning'}
            showIcon
            style={{ marginBottom: 4 }}
            message={message}
            description={description}
            action={
              <Space direction="vertical">
                <Button
                  size="small"
                  type="primary"
                  onClick={() => onEdit?.(alert.intent_id)}
                >
                  Podaljšaj
                </Button>
                <Button
                  size="small"
                  onClick={() => dispatch(ackWizardAlert(alert.wizard_id))}
                >
                  Potrdi in skrij
                </Button>
              </Space>
            }
          />
        );
      })}
      {(hiddenCount > 0 || expanded) && (
        <Button type="link" onClick={() => setExpanded(!expanded)}>
          {expanded ? 'Prikaži manj' : `Prikaži vse (${alerts.length})`}
        </Button>
      )}
    </div>
  );
};

export default RepeatExpiryAlerts;
